import * as yup from "yup";
import { FormInputMeta, FormSelectInputOptionMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IBCNbrGenMethodsDataTableRowFormMeta {
  cardNumberGenerationMethod: FormInputMeta;

  schema: any;
}

const bcnGenMethodsDataTableRowFormMeta = {} as IBCNbrGenMethodsDataTableRowFormMeta;

export const CardNumberGenerationMethodsOptions: FormSelectInputOptionMeta[] = [
    {
      label: "Algorithme CB/Random Number",
      value: "algorthmeCB_RandomNumber",
    },
    
    {
      label: "Argon2i",
      value: "argon2i",
    },

];

bcnGenMethodsDataTableRowFormMeta.cardNumberGenerationMethod = {
  name: "cardNumberGenerationMethod",
  type: "select",
  label: "Card Number Generation Method",
  options: CardNumberGenerationMethodsOptions,
  placeholder: "",
  validation: yup.string().required("Champ obligatoire !")
};

bcnGenMethodsDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(bcnGenMethodsDataTableRowFormMeta));

export default bcnGenMethodsDataTableRowFormMeta;